
// ModalPesquisarClienteBola.js

import React, { useState } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalPesquisarCliente.css';

const ModalPesquisarCliente = ({ isOpen, onClose, onClienteSelecionado }) => {
  const [searchType, setSearchType] = useState('codigo');
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSearch = async () => {
    let url = `/clientes/buscarcliente`;
    let params = {};

    if (searchType === 'codigo') {
      params = { codcli: searchValue };
    } else if (searchType === 'nome') {
      params = { nomecli: searchValue };
    } else if (searchType === 'cnpj') {
      // eslint-disable-next-line no-unused-vars
      params = { cnpjcli: searchValue };
    }

try {
    // Realizando a requisição GET com parâmetros e cabeçalhos
const response = await api.get(url);
  
  if (response.data && response.data.length > 0) {
        const cliente = response.data[0];
        setSearchResult(cliente);
        setErrorMessage('');
      } else {
        setSearchResult(null);
        setErrorMessage('Cliente não Encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar cliente:', error);
      setSearchResult(null);
      setErrorMessage('Erro ao buscar cliente: ' + error.message);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleConfirmar = () => {
    if (searchResult) {
      onClienteSelecionado(searchResult);
      onClose();
    }
  };

  return (
    isOpen && (
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={onClose}>&times;</span>
          <h3>Selecionar Cliente</h3>
          <div>
            <label>
              <input
                type="radio"
                value="codigo"
                checked={searchType === 'codigo'}
                onChange={() => setSearchType('codigo')}
              />
              Código
            </label>
            <label>
              <input
                type="radio"
                value="nome"
                checked={searchType === 'nome'}
                onChange={() => setSearchType('nome')}
              />
              Nome
            </label>
            <label>
              <input
                type="radio"
                value="cnpj"
                checked={searchType === 'cnpj'}
                onChange={() => setSearchType('cnpj')}
              />
              CNPJ
            </label>
          </div>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <div className="button-container">
            <button className="search-button" onClick={handleSearch}>Pesquisar</button>
          </div>
          {searchResult && (
            <div>
              <p>Cliente Encontrado: {searchResult.nomecli}</p>
              <div className="button-container">
                <button className="search-button" onClick={handleConfirmar}>Confirmar</button>
              </div>
            </div>
          )}
          {errorMessage && <p>{errorMessage}</p>}
        </div>
      </div>
    )
  );
}

export default ModalPesquisarCliente;